import './ForgotPasswordComponent.scss'
import ForgotPasswordEmailPage from '../ForgotPasswordEmailPage/ForgotPasswordEmailPage';
import ForgotPasswordOtpInputPage from '../ForgotPasswordOtpInput/ForgotPasswordOtpInputPage';
import ResetPasswordInputPage from '../ResetPasswordInput/ResetPasswordInputPage';
import { usePasswordResetFlow } from '../hooks/usePasswordResetFlow';
import { PasswordResetStep } from '../../../../enums/AuthFlowEnums';

interface ForgotPasswordComponentProps {
    passwordResetCompletion: () => void
}

const ForgotPasswordComponent = ({ passwordResetCompletion }: ForgotPasswordComponentProps) => {
    const flow = usePasswordResetFlow(passwordResetCompletion);

    return (
        <div className='forgot-password-window'>
            {flow.step === PasswordResetStep.Email && <ForgotPasswordEmailPage flow={flow} />}
            {flow.step === PasswordResetStep.Otp && <ForgotPasswordOtpInputPage flow={flow} />}
            {(flow.step === PasswordResetStep.NewPassword || flow.step === PasswordResetStep.Success) &&
                <ResetPasswordInputPage flow={flow} />}
        </div>
    )
}

export default ForgotPasswordComponent